import { AppType, appTypeUrl } from '../enums';

export const getSidebarEndpoint = (appType: AppType, endpoint: string): string => {
  const qlUrl = appTypeUrl[appType];
  const currentHost = window.location.protocol + '//' + window.location.host;
  const isCurrentApp = currentHost.startsWith(qlUrl);
  return isCurrentApp ? `/${endpoint}` : `${qlUrl}/${endpoint}`;
};
